import React from 'react';
import Page from '../components/Page';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from 'reactstrap';
import {
  MdDone,
  MdClear,
  MdCreate,
  MdSearch,
  MdFilterList,
} from 'react-icons/md';
import useGoogleSpreadsheet from 'use-google-spreadsheet';
//import SpreadSheets from 'components/GoogleSheet';
import axios from 'axios';
import { Redirect } from 'react-router';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { MDBDataTable, MDBTable, MDBTableHead, MDBTableBody } from 'mdbreact';
import classnames from 'classnames';
import PersonForm from '../components/PersonForm';
const API_KEY = 'AIzaSyBREzFNDCuilttXVGMcAIGdzy8dD7RHw3U';

const dropdownlist = [
  {
    name: 'Compensation Type',
    source: 'compensationTypeList',
    tbcolumn: [
      {
        label: '#',
        key: 8,
        field: 'counter',
        sort: 'asc',
      },
      {
        label: 'Name',
        key: 8,
        field: 'name',
        sort: 'asc',
      },
    ],
  },
];

class PersonPage extends React.Component {
  constructor(props) {
    super(props);

    // this.toggle = this.toggle.bind(this);
    this.state = {
      redirect: false,
      modal: false,
      isEdit: false,
      personTypeList: [],
      personList: [],
      activeTab: '1',
      url: '',
      sheetData: [],
      typeName: '',
      dataFieldList: [],
      personId: '',
    };

    this.setData = this.setData.bind(this);
  }

  get resetState() {
    return {
      url: '',
      sheetData: [],
    };
  }

  reset = () => {
    this.setState({
      url: '',
      sheetData: [],
    });
  };

  setData = data => {
    if (data) {
      this.interval = setTimeout(() => {
        this.setState({
          sheetData: data,
        });
      }, 800);
      if (this.state.sheetData.length == data.length) {
        clearInterval(this.interval);
      }
    }
  };

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
        typeName:
          tab === '0'
            ? 'All'
            : this.state.personTypeList[parseInt(tab) - 1].name,
        personList: [],
      });
    }

    setTimeout(() => this.getPersonDataField(), 500);
  }

  toggleModal = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit:
        id != undefined || (id != null && action == 'EDIT') ? true : false,
      personId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    });
  };

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      modal: false,
    });

    if (reload) {
      window.location.reload();
    } else {
      this.getPersonList();
    }
  };

  update = event => {
    event.preventDefault();
    if (this.state.sheetData.length < 1) {
      alert('No data to update');
      return;
    }

    const selected_org = StorageService.getSession('selected_org');
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
      CompanyID: selected_org.CompanyID,
      SheetData: this.state.sheetData,
      PersonType: this.state.typeName,
    };

    axios
      .post(url + ':3000/v1/person/import', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          return;
        } else {
          this.notificationSystem.addNotification({
            title: <MdDone />,
            message: this.state.typeName + ' updated successfully.',
            level: 'success',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          this.setState(this.resetState);
          this.getPersonList();
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  timesheet = id => {
    this.props.history.push({
      pathname: '/person/' + id + '/timesheet',
    });
  };

  activity = id => {
    this.props.history.push({
      pathname: '/person/' + id + '/activity',
    });
  };

  getPersonList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const comp = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
      CompanyID: comp.CompanyID,
      PersonType: this.state.typeName,
    };

    axios
      .post(url + ':3000/v1/person/get', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ personList: result.data });
      })
      .catch(error => {
        //alert(error);
      });
  };

  getPersonDataField = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const comp = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
      CompanyID: comp.CompanyID,
      PersonType: this.state.typeName,
    };

    axios
      .post(url + ':3000/v1/person/getDataField', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ dataFieldList: result.data });
        this.getPersonList();
      })
      .catch(error => {
        alert(error);
      });
  };

  getPersonTypeList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
    };

    axios
      .post(url + ':3000/v1/dropdownlist/personType', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ personTypeList: result.data });
        if (result.data.length > 0) {
          this.setState({
            typeName: result.data[0].name,
          });
          this.getPersonDataField();
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  delete = id => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
      PersonID: id,
    };

    axios
      .post(url + ':3000/v1/person/delete', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          return;
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: this.state.typeName + ' removed successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });
        this.getPersonList();
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    if (StorageService.getSession('selected_org') === null) {
      this.setState({
        redirect: true,
      });
    } else {
      this.getPersonTypeList();
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }

    const { activeTab } = this.state;

    return (
      <Page
        className="PersonPage"
        title="Person"
        breadcrumbs={[{ name: 'Person', active: true }]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <Row>
                  <Col md={9} className="mb-0">
                    <Form onSubmit={this.update} className="AuthForm">
                      <FormGroup row className="mb-0">
                        <Col sm={6} className="pr-0">
                          <Input
                            type="text"
                            name="url"
                            placeholder="Paste Google Sheet URL here..."
                            value={this.state.url}
                            onChange={this.changeHandler}
                            required
                          />
                        </Col>
                        <Col sm={6}>
                          <div className="d-flex">
                            <Button
                              color="link"
                              className="theme-button theme-button-primary mr-2"
                              type="submit"
                              disabled={
                                this.state.sheetData.length < 1 ? true : false
                              }
                            >
                              Import
                            </Button>
                            <Button
                              className="theme-button theme-button-secondary"
                              onClick={() => this.reset()}
                            >
                              Clear
                            </Button>
                          </div>
                        </Col>
                      </FormGroup>
                    </Form>
                  </Col>
                  <Col xl={3} lg={3} md={3} className="mb-0 text-right">
                    <Button
                      className="theme-button theme-button-primary"
                      onClick={this.toggleModal('ADD', null)}
                    >
                      Create
                    </Button>
                  </Col>
                </Row>

                {/* <SpreadSheets
                  style={{ clear: 'both', display: 'block' }}
                  setSheetData={this.setData}
                  {...this.state}
                /> */}

                <Nav tabs className="ps-tab">
                  {/* <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === '0',
                      })}
                      onClick={() => {
                        this.toggle('0');
                      }}
                    >
                      All
                    </NavLink>
                  </NavItem> */}
                  {this.state.personTypeList.length > 0 &&
                    this.state.personTypeList.map((item, index) => {
                      return (
                        <NavItem key={index}>
                          <NavLink
                            className={classnames({
                              active: activeTab === (index + 1).toString(),
                            })}
                            onClick={() => {
                              this.toggle((index + 1).toString());
                            }}
                          >
                            {item.name}
                          </NavLink>
                        </NavItem>
                      );
                    })}
                </Nav>

                <TabContent activeTab={activeTab}>
                  {this.state.personTypeList.length > 0 &&
                    this.state.personTypeList.map((item, index) => {
                      return (
                        <TabPane
                          key={index}
                          tabId={(index + 1).toString()}
                          className="py-3"
                        >
                          <Table responsive hover className="ps-table tb-col-5">
                            <thead>
                              <tr>
                                {this.state.dataFieldList.length > 0 &&
                                  this.state.dataFieldList.map((k, kindex) => {
                                    return <th key={kindex}>{k.FieldName}</th>;
                                  })}
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.personList.length < 1 && (
                                <tr>
                                  <td colSpan="3">
                                    <div className="ps-empty-data">
                                      <div className="empty-content">
                                        <MdCreate />
                                        <h4>No data to show</h4>
                                        <span>
                                          Click the 'Create' button to add new
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              )}

                              {this.state.personList.length > 0 &&
                                this.state.personList.map((p, pindex) => {
                                  return (
                                    <tr key={pindex}>
                                      {this.state.dataFieldList.length > 0 &&
                                        this.state.dataFieldList.map(
                                          (k, kindex) => {
                                            return (
                                              <td key={kindex}>
                                                {p.PersonID &&
                                                  p.PersonData[k.FieldName]}
                                              </td>
                                            );
                                          },
                                        )}

                                      <td>
                                        <div className="ps-action-button">
                                          {this.state.activeTab === '1' && (
                                            <Button
                                              className="theme-button theme-button-dark"
                                              onClick={() =>
                                                this.timesheet(
                                                  p.PersonData['ID'],
                                                )
                                              }
                                            >
                                              Timesheet
                                            </Button>
                                          )}

                                          <Button
                                            className="theme-button theme-button-primary"
                                            onClick={() =>
                                              this.activity(p.PersonData['ID'])
                                            }
                                          >
                                            Activity
                                          </Button>
                                          <Button
                                            className="theme-button theme-button-secondary"
                                            onClick={this.toggleModal(
                                              'EDIT',
                                              p.PersonID,
                                            )}
                                          >
                                            Edit
                                          </Button>
                                          <Button
                                            className="theme-button theme-button-primary-light"
                                            onClick={() =>
                                              this.delete(p.PersonID)
                                            }
                                          >
                                            Delete
                                          </Button>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </Table>
                          {/* <MDBDataTable
                            key={index}
                            searching={false}
                            data={{
                              columns: item.tbcolumn,
                              rows: this.state[item.source],
                            }}
                          /> */}
                        </TabPane>
                      );
                    })}
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggleModal()}
          className={this.props.className}
          centered
          style={{ minWidth: '700px' }}
        >
          <PersonForm
            history={this.props.history}
            onToggleModal={this.toggleModal}
            closeModal={this.closeModal}
            data={this.state}
          />
        </Modal>
      </Page>
    );
  }
}

// const SpreadSheets = ({ ...props }) => {
//   let rows = [];
//   let isFetching = false;
//   let sheetUrl = props.url;

//   if (sheetUrl) {
//     const res = useGoogleSpreadsheet(sheetUrl, API_KEY); //change the plugin regex to /docs.google.com\/spreadsheets\/d\/([a-zA-Z0-9-_]*)/
//     if (res.rows !== null && res.rows.length > 0) {
//       rows = res.rows.filter(function (i) {
//         return i.ID !== null && i.ID !== '' && i.Name !== null && i.Name !== '';
//       });
//     }
//     isFetching = res.isFetching;
//     props.setSheetData(rows);
//   }

//   return (
//     <>
//       {isFetching ? (
//         <div className="loading">Loading...</div>
//       ) : (
//         <p>Total of records: {rows ? rows.length : 0}</p>
//       )}
//     </>
//   );
// };
export default PersonPage;
